/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect } from "react";
import { FaLink } from "react-icons/fa";
import Tag from "./Tag";
import Aos from "aos";
import "aos/dist/aos.css";


function ProjectCard({ data}) {
    useEffect(() => {
        Aos.init({duration: 2000});
      
      }, [])
  return (
    <div className="flex flex-col overflow-hidden rounded-lg shadow-lg  transform hover:scale-110  duration-1000 ease-in-out" >
    <div className="relative  h-56 flex bg-gray-100">
        <img className="object-contain w-full mx-auto"
            src={data.image}
            alt="" />
        <a
            href={data.link}
            target="_blank"
            className="absolute bottom-0 right-0 inline-flex items-center px-3 py-1 mr-4 -mb-3 text-xs font-medium leading-tight text-blue-800 bg-gray-100 border rounded-full cursor-pointer">
              <FaLink className="inline-block mr-1" /> Visit
            </a>
    </div>
    <div className="flex flex-col justify-between flex-1">
        <div className="flex flex-col justify-between flex-1 p-6 bg-white">
            <div>
                <span href="#" className="block text-lg md:text-xl font-semibold leading-7 text-gray-900">{data.title}</span>
                <p className="mt-3 text-sm md:text-base leading-6 text-gray-500">
                {data.desc}
                </p>
            </div>
            <p className="mt-3 text-xs md:text-sm font-medium leading-5">
              {data.languages.map((x) => (<Tag value={x.name} classes={x.classes} />))}

            </p>
        </div>
        <div className="flex items-center justify-between p-6 bg-gray-100">
            
            <div className="ml-3">
                <p className="text-sm font-medium leading-5 text-gray-900">
                    <span href="#" className="hover:underline">From</span>
                </p>
                <div className="text-xs leading-5 text-gray-600">
                {data.from}
                </div>
            </div>
            <div className="ml-3 text-right">
                <p className="text-sm font-medium leading-5 text-gray-900">
                    <span href="#" className="hover:underline">To</span>
                </p>
                <div className="text-xs leading-5 text-gray-600">
                {data.to}
                </div>
            </div>
        </div>
    </div>
</div>


  );
}

export default ProjectCard;